function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import flow from 'lodash/fp/flow';
import identity from 'lodash/fp/identity';
import isUndefined from 'lodash/fp/isUndefined';
import pull from 'lodash/fp/pull';
import set from 'lodash/fp/set';
import { DELETE_ACTIVITY, DISABLE_ACTIVITY_FILTER, ENABLE_ACTIVITY_FILTER, FILTER_ACTIVITIES, LIST_ACTIVITIES, LIST_ACTIVITIES_SUCCESS, SUPERSEDE_ACTIVITY, TOGGLE_STAFF_ACTIVITIES } from '../constants/activity';
import { DELETE_ASSET } from '../constants/asset';
var defaultMapState = {
    projects: {},
    enabledFilters: [],
    isStaffActivityListVisible: false
};
var activityReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultMapState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case LIST_ACTIVITIES:
            {
                return flow([
                    set([
                        'projects',
                        action.payload.projectId,
                        'ui',
                        'isLoading'
                    ], true)
                ])(state);
            }
        case TOGGLE_STAFF_ACTIVITIES:
            {
                return flow([
                    set('isStaffActivityListVisible', !state.isStaffActivityListVisible)
                ])(state);
            }
        case LIST_ACTIVITIES_SUCCESS:
            {
                var _action_payload = action.payload, projectId = _action_payload.projectId, activities = _action_payload.activities;
                return flow([
                    set([
                        'projects',
                        projectId,
                        'ui',
                        'isLoading'
                    ], false),
                    set([
                        'projects',
                        projectId,
                        'activities'
                    ], activities),
                    set([
                        'projects',
                        projectId,
                        'nonFilteredActivities'
                    ], activities)
                ])(state);
            }
        case FILTER_ACTIVITIES:
            {
                var _state_projects_projectId;
                var _action_payload1 = action.payload, projectId1 = _action_payload1.projectId, activities1 = _action_payload1.activities;
                return flow([
                    set([
                        'projects',
                        projectId1,
                        'activities'
                    ], activities1),
                    isUndefined((_state_projects_projectId = state.projects[projectId1]) === null || _state_projects_projectId === void 0 ? void 0 : _state_projects_projectId.nonFilteredActivities) ? set([
                        'projects',
                        projectId1,
                        'nonFilteredActivities'
                    ], activities1) : identity
                ])(state);
            }
        case ENABLE_ACTIVITY_FILTER:
            {
                var filterName = action.payload.filterName;
                return flow([
                    set([
                        'enabledFilters'
                    ], state.enabledFilters.concat(filterName))
                ])(state);
            }
        case DISABLE_ACTIVITY_FILTER:
            {
                var filterName1 = action.payload.filterName;
                return flow([
                    set([
                        'enabledFilters'
                    ], pull(filterName1, state.enabledFilters))
                ])(state);
            }
        case DELETE_ACTIVITY:
            {
                var _state_projects;
                var _action_payload2 = action.payload, projectId2 = _action_payload2.projectId, activityId = _action_payload2.activityId;
                var _ref = ((_state_projects = state.projects) === null || _state_projects === void 0 ? void 0 : _state_projects[projectId2]) || {}, _ref_activities = _ref.activities, activities2 = _ref_activities === void 0 ? [] : _ref_activities, _ref_nonFilteredActivities = _ref.nonFilteredActivities, nonFilteredActivities = _ref_nonFilteredActivities === void 0 ? [] : _ref_nonFilteredActivities;
                var updatedActivities = activities2.reduce(function(acc, activity) {
                    if (activity.id === activityId) {
                        // Skip this activity as it's being superseded
                        return acc;
                    }
                    acc.push(activity);
                    return acc;
                }, []);
                var filteredNonFilteredActivities = nonFilteredActivities.filter(function(activity) {
                    return activity.id !== activityId;
                });
                return flow([
                    set([
                        'projects',
                        projectId2,
                        'activities'
                    ], updatedActivities),
                    set([
                        'projects',
                        projectId2,
                        'nonFilteredActivities'
                    ], filteredNonFilteredActivities)
                ])(state);
            }
        case DELETE_ASSET:
            {
                var _action_payload3 = action.payload, projectId3 = _action_payload3.projectId, activityId1 = _action_payload3.activityId, assetId = _action_payload3.assetId;
                var index = state.projects[projectId3].activities.findIndex(function(activity) {
                    return activity.id === activityId1;
                });
                var assets = state.projects[projectId3].activities[index].created_assets.filter(function(asset) {
                    return asset.id !== assetId;
                });
                return flow([
                    set([
                        'projects',
                        projectId3,
                        'activities',
                        index,
                        'created_assets'
                    ], assets)
                ])(state);
            }
        case SUPERSEDE_ACTIVITY:
            {
                var _state_projects1;
                var _action_payload4 = action.payload, projectId4 = _action_payload4.projectId, activityId2 = _action_payload4.activityId, supersededAssets = _action_payload4.supersededAssets;
                var _ref1 = ((_state_projects1 = state.projects) === null || _state_projects1 === void 0 ? void 0 : _state_projects1[projectId4]) || {}, _ref_activities1 = _ref1.activities, activities3 = _ref_activities1 === void 0 ? [] : _ref_activities1, _ref_nonFilteredActivities1 = _ref1.nonFilteredActivities, nonFilteredActivities1 = _ref_nonFilteredActivities1 === void 0 ? [] : _ref_nonFilteredActivities1;
                var updatedActivities1 = activities3.reduce(function(acc, activity) {
                    if (activity.id === activityId2) {
                        acc.push(_object_spread_props(_object_spread({}, activity), {
                            superseded_assets: supersededAssets
                        }));
                    } else {
                        acc.push(activity);
                    }
                    return acc;
                }, []);
                var updatedNonFilteredActivities = nonFilteredActivities1.reduce(function(acc, activity) {
                    if (activity.id === activityId2) {
                        acc.push(_object_spread_props(_object_spread({}, activity), {
                            superseded_assets: supersededAssets
                        }));
                    } else {
                        acc.push(activity);
                    }
                    return acc;
                }, []);
                return flow([
                    set([
                        'projects',
                        projectId4,
                        'activities'
                    ], updatedActivities1),
                    set([
                        'projects',
                        projectId4,
                        'nonFilteredActivities'
                    ], updatedNonFilteredActivities)
                ])(state);
            }
        default:
            return state;
    }
};
export default activityReducer;
